import React, { useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table, Input, /* Tooltip, Switch, */ Popover } from "antd";
import { useIntl, FormattedMessage } from "react-intl";
import numeral from "numeral";
import { notification } from "antd";
import { openNotificationWithIcon } from "../../../libs/utils";
import { useState } from "react";
import { CSVLink } from "react-csv";
import ReactToPrint from "react-to-print";
import { Button } from "@ts-digital/vrc";
// import CustomChip from "../../general/chips";
import { useDispatch, useSelector } from "react-redux";
import { getDepreciationList } from "../../../store/actions/accountingYears";
import { getFixedAssetsList } from "../../../store/actions/precog/assets";
import EmptyDashboardData from "../../preCog/toBeAccountantContent/emptyDashboardData";
import LoaderSimple from "../../general/loader";
import moment from "moment";
import { DATE_FORMAT_FOR_DISPLAY } from "../../../constants/constants";
import AmmortamentiImg from "../../../assets/img/ammortamenti.svg";

const DepreciationModal = ({selectedSequenceNumber, startDate, endDate}) => {

  // const [suspensions, setSuspensions] = useState([]);
  // const [isCivilSuspended, setIsCivilSuspended] = useState(true);
  // const [isFiscalSuspended, setIsFiscalSuspended] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const printPDF = useRef();
  const [/* filterChips, */ , setFilterChips] = useState([]);
  const [filterSelected /* , setFilterSelected */] = useState(["COMMERCIAL", "INDUSTRIAL", "AGRICULTURE"]);
  const dispatch = useDispatch();
  const fixedAssetsObj = useSelector(state => state.precog?.fixedAssets);
  const fixedList = fixedAssetsObj?.list;
  const depreciationListApi = useSelector(state => state?.precog?.accountingYearsDepreciation?.data);
  const depreciationListStatus = useSelector(state => state?.precog?.accountingYearsDepreciation?.status);

  useEffect(() => {
    const filters = {status: "ACTIVE", purchaseDateFrom: startDate, purchaseDateTo: endDate};
    dispatch(getFixedAssetsList(null, filters));
  }, []);

  useEffect(() => {
    const dataToSend = {
      businesess: [],
      start: startDate,
      end: endDate,
      map: null
    };
    dispatch(getDepreciationList(dataToSend));
  }, [fixedList]);

  useEffect(() => {
    setFilterChips([{
      key: "COMMERCIAL",
      desc: "Commercio",
      active: filterSelected.includes("COMMERCIAL") ? true : false
    },
    {
      key: "INDUSTRIAL",
      desc: "Industria",
      active: filterSelected.includes("INDUSTRIAL") ? true : false
    },
    {
      key: "AGRICULTURE",
      desc: "Agricoltura",
      active: filterSelected.includes("AGRICULTURE") ? true : false
    }]);  
  }, []);

  useEffect(() => {
    const csvDataToExport = depreciationListApi?.map(i => {
      return {
        Ammortamento: i.depreciationTitle,
        Valore: i.depreciationTotalValue,
        Ammortamento_Effettivo: i.effectiveDepreciationValue,
        Totale: depreciationsTotal,
        Ammortamento_Effettivo_Totale: effectiveDepreciationTotals
      };
    });
    setCsvData(csvDataToExport);
  }, []);

  const isError = depreciationListStatus?.error;
  const isLoading = depreciationListStatus?.started && !depreciationListStatus?.ended;

  const depreciationsArray = depreciationListApi?.filter(obj => !obj.isChildren);
  const totals = depreciationsArray?.map(d => d.depreciationTotalValue);
  const depreciationsTotal = totals && totals.length > 0 ? totals.reduce?.((a,b) => a + b) : 0;

  const effectiveTotals = depreciationsArray?.map(d => d.effectiveDepreciationValue);
  const effectiveDepreciationTotals = effectiveTotals && effectiveTotals.length > 0 ? effectiveTotals?.reduce((a,b) => a + b) : 0;
 
  // const onSuspensionBlur = (e, record) => {
  //   setSuspensions([...suspensions, {key: record.key, suspensionValue: Number(e.target.value)}]);
  // };

  // const uniqueIds = [];

  // const unique = suspensions.filter(element => {
  //   const isDuplicate = uniqueIds.includes(element.key);

  //   if (!isDuplicate) {
  //     uniqueIds.push(element.key);

  //     return true;
  //   }

  //   return false;
  // });

  const downloadPopoverContent = (
    <>
      <ReactToPrint
        trigger={() => (
          <div className="popover-content-row">
            <span className="popover-text">PDF</span>
          </div>
        )}
        content={() => printPDF.current}
      />
      <CSVLink
        data={csvData || []}
        filename={
          "Ammortamenti" + new Date().toDateString().replaceAll(" ", "_") + ".csv"
        }>
        <div className="popover-content-row">
          <span className="popover-text">CSV</span>
        </div>
      </CSVLink>
    </>
  );

  // const calcSectorContainerStyles = value => {
  //   return {
  //     border: value === "commercio" ? "1px solid rgb(117, 63, 131)" : value === "industria" ? "1px solid rgb(13, 108, 128)" : "1px solid rgb(197, 48, 144)"
  //   };
  // };

  // const calcSectorTextStyles = value => {
  //   return {
  //     color: value === "commercio" ? "rgb(117, 63, 131)" : value === "industria" ? "rgb(13, 108, 128)" : "rgb(197, 48, 144)"
  //   };
  // };

  // const onChangeCivil = () => setIsCivilSuspended(!isCivilSuspended);

  // const onChangeFiscal = () => setIsFiscalSuspended(!isFiscalSuspended);

  // const calculateSectorTotal = sector => {
  //   const sectoreDepreciationArray = depreciationListApi?.filter(obj => !obj.isChildren).filter(obj => obj.sector === sector);
  //   const arrayAgrTotals = sectoreDepreciationArray?.map(d => d.depreciationTotalValue);
  //   const sectorTotal = arrayAgrTotals?.reduce((a,b) => a + b);
  //   return `${numeral(sectorTotal).format("0,0.00")} €`;
  // };

  // const totalTooltipText = (
  //   <div>
  //     <p style={{margin: 0}}> Commercio : {calculateSectorTotal("commercio")}</p> 
  //     <p style={{margin: 0}}> Industria: {calculateSectorTotal("industria")}</p>
  //     <p style={{margin: 0}}> Agricoltura: {calculateSectorTotal("agricoltura")}</p>
  //   </div>
  // );

  /** TODO non cancellare
  const goToDetail = assetId => {
    // sostituire assetId nell'url del navigate quando sapremo come risalire all'id del draft a partire dall'id del cespite
    navigate(`/precog-detail/${assetId}`, {state: {isFromRisconti: true, assetId: assetId}});    
  };
  */

  const initial = {
    key: "initial",
    depreciationTitle: "initial",
    depreciationTotalValue: "initial",
    found: "initial",
    debit: "initial",
    credit: "initial",
    suspension: "initial",
    civil: "initial",
    fiscal: "initial",
    isChildren: false,
    sector: "initial",
    effectiveDepreciationValue: "initial",
    children: []
  };

  const columns = [
    {
      title: "Ammortamento",
      dataIndex: "depreciationTitle",
      key: "depreciationTitle",
      render: (text, record) => text === "initial" ? null : 
        record.isChildren ? 
          (<div style={{display: "flex", justifyContent: "space-between"}}>
            <span style={{marginRight: 30}} className={"depreciationTitleChildren"}>{text}</span>
            {/* <FontAwesomeIcon icon={["far", "external-link-square-alt"]} style={{color: "rgb(0, 144, 209)", cursor: "pointer"}} onClick={() => goToDetail(record.assetId)}/>*/}
          </div>)
          :
          <span style={{marginRight: 30}}className={"depreciationTitle"}>{text}</span>,
      width: "60%"
    },
    // {
    //   title: "",
    //   dataIndex: "sector",
    //   key: "sector",
    //   render: (text, record) => text === "initial" ? null : (!record?.isChildren && <div className="sectorContainer" style={calcSectorContainerStyles(text)}><span className="sectorText" style={calcSectorTextStyles(text)}>{text}</span></div>),
    //   width: "5%"
    // },
    {
      title: "",
      dataIndex: "depreciationTotalValue",
      key: "depreciationTotalValue",
      render: value => value === "initial" ? null : (`${numeral(value).format("0,0.00")} €`),
      width: "20%"
    },
    // {
    //   title: "Sospensione",
    //   dataIndex: "suspension",
    //   key: "suspension",
    //   render: (text, record) => text === "initial" ? 
    //     <div className={"supensions-toggles-container"}>
    //       <div className="toggle">
    //         <span className="toggle-title">Civilistica</span>
    //         <Switch checked={isCivilSuspended} onChange={onChangeCivil} />
    //       </div>
    //       <div className="toggle">
    //         <span className="toggle-title">Fiscale</span>
    //         <Switch checked={isFiscalSuspended} onChange={onChangeFiscal} />
    //         <Tooltip placement="right" title="prova" color={"rgb(255, 255, 255)"}>
    //           <FontAwesomeIcon
    //             icon={["fas", "info-circle"]}
    //             style={{
    //               color: "#0090d1",
    //               cursor: "pointer",
    //               fontSize: "15px",
    //               margin: "2px 0 0 10px"
    //             }}
    //           />
    //         </Tooltip>
    //       </div>
    //     </div>
    //     : 
    //     <Input className="suspensionInput" placeholder="% sospensione" bordered={false} onBlur={e => onSuspensionBlur(e, record)}/>,
    //   width: "14%"
    // },
    {
      title: "Ammortamento effettivo",
      dataIndex: "effectiveDepreciationValue",
      key: "effectiveDepreciationValue",
      render: value => value === "initial" ? null : (`${numeral(value).format("0,0.00")} €`),
      width: "20%"
    }
  ];

  const mockedDataInput = {
    year: selectedSequenceNumber,
    depreciationDate: moment(endDate).format(DATE_FORMAT_FOR_DISPLAY)
  };

  const dateInputs = [
    {
      title: useIntl().formatMessage({id: "accountingYear.yearDateTitle"}),
      input: <Input defaultValue={mockedDataInput?.year} disabled={true}/>
    }, 
    {
      title: useIntl().formatMessage({id: "accountingYear.depreciationDateTitle"}),
      input: <Input defaultValue={mockedDataInput?.depreciationDate} disabled={true}/>
    }
  ];

  const generateDepreciation = () => {
    const assets = depreciationListApi?.flatMap(el => el.children);
    const rowsIds = assets?.map(r => r.assetId);
    const dataToMapObj = rowsIds?.reduce((obj, item) => Object.assign(obj, { [item]: {percentage: "0", applicationScope: "STATUTORY"} }), {});
    const dataToSend = {
      businesess: [],
      start: startDate,
      end: endDate,
      map: dataToMapObj
    };
    dispatch(getDepreciationList(dataToSend)).then(res => 
      openNotificationWithIcon(
        notification,
        "success",
        "",
        "Ammortamento generato correttamente",
        null,
        null
      )).catch(err => 
      openNotificationWithIcon(
        notification,
        "error",
        "",
        "Spiacenti. Si è verificato un errore. Riprova a generare l'ammortamento",
        null,
        null
      ));
  };

  const renderFooter = () => {
    return (
      <div className="footer-container">
        <div style={{width: "calc(70% - 32px)"}}></div>
        <div style={{width: "calc(20% + 32px)"}}><span className="total-text"> Totale {`${numeral(depreciationsTotal).format("0,0.00")} €`}</span></div>
        <div style={{width: "20%"}}><span className="total-text"> Totale {`${numeral(effectiveDepreciationTotals).format("0,0.00")} €`}</span></div>

      </div>
    );
  };

  return (    
    <div ref={printPDF}>      
      <div className="operation-modal-container">
        {!depreciationListApi || depreciationListApi.length === 0 ?
          <div className="documentWithSearch-banner-not-found">
            <div><img src={AmmortamentiImg} alt="" /></div>
            <div style={{marginTop: "20px"}}><FormattedMessage id="accountingYear.depreciationModal.yetDepreciation" /></div>
          </div>
          :
          <div>
            <div className="operation-modal-header">
              <div className="sub-content left depreciation">
                {dateInputs.map((i, index) => {
                  return (
                    <div key={index} className="date-container">
                      <h5 className="date-title">{i.title}</h5>
                      {i.input}
                    </div>
                  );
                })
                }
                {/* <div className="depreciationModalChipsContainer">
              {
                filterChips.map((el, key) => {
                  return (
                    <CustomChip
                      style={{ margin: "5px 24px 0 0", cursor: "pointer" }}
                      key={`filterChip_${el.key}`}
                      active={filterChips[key].active}
                      className={filterChips[key].active ? "active" : ""}
                      onClick={() => {
                        const cloneFilterChips = [...filterChips];
                        cloneFilterChips[key].active = !cloneFilterChips[key].active;              
                        setFilterChips(cloneFilterChips);
                      }}
                      description={el.desc}
                    />
                  );
                })
              }
            </div> */}
              </div>
              <div className="sub-content right">
                <Popover 
                  placement="bottom" 
                  trigger="hover" 
                  content={downloadPopoverContent}
                  getPopupContainer={trigger => trigger.parentNode}
                  zIndex={1000000}
                  overlayClassName={"download-popover-content"}
                >
                  <FontAwesomeIcon
                    icon={["far", "download"]}
                    style={{
                      color: "#0090d1",
                      cursor: "pointer"
                    }}
                  />
                </Popover>
              </div>
            </div>
            { !isLoading && !isError && depreciationListApi !== undefined ? 
              <Table
                className="vaporTable depreciationTable yearsOperationsTable" 
                rowClassName={record => record.isChildren && "table-row-blue"}
                columns={columns}  
                dataSource={[initial, ...depreciationListApi]}    
                pagination={false} 
                // rowSelection={{
                //   checkStrictly: false,
                //   getCheckboxProps: () => ({
                //     className: "tableSelectCheckboxOverride"
                //   }),
                //   ...rowSelection
                // }}
                footer={() => renderFooter()}
                expandable={{
                  indentSize: 35,
                  expandedRowClassName: "childrenRow",
                  expandIcon: ({ expanded, onExpand, record }) => 
                    record?.children?.length > 0 &&
                     <FontAwesomeIcon
                       icon={[
                         "fas",
                         expanded ? "chevron-down" : "chevron-right"
                       ]}
                       onClick={e => onExpand(record, e)}
                     />
                }}     
              />
              : isError ? <EmptyDashboardData>
                <>
                  <p className="empty-dashboard-text"><FormattedMessage id="preCog.accountingTab.noResults_error" /></p>
                </>
              </EmptyDashboardData>
                : <LoaderSimple /> 
            }
          </div>
        }
        <footer className="depreciationModalFooter">

          {!depreciationListApi || depreciationListApi.length === 0 ?
            <Button kind="primary" size="large"  onClick={() => console.log("TODO")} >
              {" "}
              <FormattedMessage id="accountingYear.depreciationModal.footerCancelCta" />{" "}
            </Button>
            :
            <Button kind="primary" size="large"  onClick={() => generateDepreciation()} >
              {" "}
              <FormattedMessage id="accountingYear.depreciationModal.footerCta" />{" "}
            </Button>
          }
        </footer>
      </div>
    </div>
  );
};

export default DepreciationModal;